import React, { useCallback } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import { useHistory } from 'hooks/useHistory'
import { GET_ONE_QUESTION, UPDATE_QUESTION } from 'queries/question'
import { updateQuestion, updateQuestionVariables } from '__generatedTypes__/updateQuestion'
import { UpdateQuestionInput } from '__generatedTypes__/globalTypes'
import { findOneQuestion, findOneQuestionVariables } from '__generatedTypes__/findOneQuestion'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import { QUERY_PARAM, QUESTION_TEMPLATES_TAB } from 'pagesNew/Questions/QuestionTabs'
import { PageLoader } from 'components/PageLoader'
import { toast } from 'utils/toast'
import { Form } from '../../Form'

export const Edit = () => {
  const { questionTemplateId = '' } = useParams()
  const { navigate } = useLink()

  const { loadingHistory, populateHistoryWithUser } = useHistory()

  const [update] = useMutation<updateQuestion, updateQuestionVariables>(UPDATE_QUESTION)

  const { data, loading } = useQuery<findOneQuestion, findOneQuestionVariables>(GET_ONE_QUESTION, {
    variables: {
      params: questionTemplateId,
    },
    fetchPolicy: 'network-only',
  })
  const questionTemplate = data?.findOneQuestion

  const handleSubmit = useCallback(
    async (question: UpdateQuestionInput) => {
      try {
        await update({
          variables: {
            params: {
              id: questionTemplateId,
              ...question,
              history: populateHistoryWithUser(question.history),
            },
          },
        })

        navigate(
          cmsRoutes.QUESTION_LIST,
          {},
          {
            searchParams: new URLSearchParams({
              [QUERY_PARAM]: QUESTION_TEMPLATES_TAB.id,
            }),
          }
        )

        toast.success('Question template updated successfully')
      } catch (error) {
        toast.error('Failed to update question template')
      }
    },
    [populateHistoryWithUser, update]
  )

  if (loading || loadingHistory) {
    return <PageLoader />
  }

  if (!questionTemplate) {
    return (
      <div style={{ padding: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1>Question template not found</h1>
        </div>
      </div>
    )
  }

  return (
    <div>
      <Form isTemplate question={questionTemplate} onSubmit={handleSubmit} />
    </div>
  )
}
